import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchReal } from "../utils/fetch";
import { ChatBubbleBottomCenterTextIcon } from "@heroicons/react/24/outline";

const formatTestimonials = (testimonials) => {
  const allTestimonials = [];
  testimonials.map((testimonial) => {
    const render = {
      writer: testimonial.name,
      testimonial: testimonial.testimonialBody,
    };
    allTestimonials.push(render);
    return allTestimonials;
  });
  return allTestimonials;
};

function TestimonialWidget() {
  const [testimonials, setTestimonials] = useState(null);
  useEffect(() => {
    const getTestimonials = async () => {
      try {
        const response = await fetchReal("/testimonial/get?type=rand", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        if (!data.success) throw new Error(data.message);
        setTestimonials(formatTestimonials(data.testimonials));
      } catch (error) {
        console.log(error);
      }
    };

    getTestimonials();
  }, []);
  return (
    <>
      <h3 className="tw-mr-2 tw-flex tw-flex-row tw-items-center tw-mb-2 tw-w-fit tw-border-b-2 tw-border-sky-700 tw-rounded-lg tw-px-2 tw-py-1 tw-mx-1 sm:tw-mx-6">
        <ChatBubbleBottomCenterTextIcon className="tw-mr-1 tw-w-7 tw-text-black" />
        <span className="tw-text-xl tw-font-bold tw-text-black">
          Testimonials
        </span>
        <span className="tw-ml-1">
          <Link
            to="/testimonial/see-all"
            className="tw-underline tw-decoration-sky-700 tw-text-sky-700 tw-text-xs hover:tw-decoration-double hover:tw-text-sky-800 hover:tw-decoration-sky-800"
          >
            See All
          </Link>
        </span>
      </h3>
      <div className="tw-grid tw-grid-cols-3 tw-gap-1 tw-my-2 tw-mx-1 sm:tw-mx-6">
        {testimonials &&
          testimonials.length > 0 &&
          testimonials.map((testimonial, index) => (
            <section
              key={index}
              className="tw-relative tw-isolate tw-overflow-hidden tw-bg-white tw-border tw-border-indigo-100 tw-rounded-lg tw-px-6 tw-py-8 sm:tw-py-5 lg:tw-px-8"
            >
              <div className="tw-absolute tw-inset-0 -tw-z-10 tw-bg-[radial-gradient(45rem_50rem_at_top,theme(colors.sky.100),white)] tw-opacity-20" />
              <div className="tw-absolute tw-inset-y-0 tw-right-1/2 -tw-z-10 tw-mr-16 tw-w-[200%] tw-origin-bottom-left tw-skew-x-[-30deg] tw-bg-white tw-shadow-xl tw-shadow-indigo-600/10 tw-ring-1 tw-ring-indigo-50 sm:tw-mr-28 lg:tw-mr-0 xl:tw-mr-16 xl:tw-origin-center" />
              <div className="tw-mx-auto tw-max-w-2xl lg:tw-max-w-4xl">
                <figure className="tw-mt-10">
                  <blockquote className="tw-text-center tw-break-words tw-text-xl tw-font-semibold tw-leading-8 tw-text-gray-900 sm:tw-text-2xl sm:tw-leading-9">
                    <p>“{testimonial.testimonial}”</p>
                  </blockquote>
                  <figcaption className="tw-mt-10">
                    <div className="tw-mt-4 tw-flex tw-items-center tw-justify-center tw-space-x-3 tw-text-base">
                      <div className="tw-font-semibold tw-italic tw-text-gray-900">
                        - {testimonial.writer}
                      </div>
                    </div>
                  </figcaption>
                </figure>
              </div>
            </section>
          ))}
        {testimonials && testimonials.length === 0 && (
          <p>
            😔 We don't have any testimonials yet! Be the first to{" "}
            <Link
              to="/testimonial/new"
              className="tw-font-bold tw-text-sky-700"
            >
              leave us one.
            </Link>
          </p>
        )}
      </div>
    </>
  );
}

export default TestimonialWidget;
